import { render } from "./DerekCrane.vue?vue&type=template&id=2bcbc6fa&ts=true"
import script from "./DerekCrane.vue?vue&type=script&lang=ts"
export * from "./DerekCrane.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__